(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-type', {
            parent: 'entity',
            url: '/event-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-type/event-types.html',
                    controller: 'EventTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-type-detail', {
            parent: 'entity',
            url: '/event-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-type/event-type-detail.html',
                    controller: 'EventTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventType', function($stateParams, EventType) {
                    return EventType.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-type.new', {
            parent: 'event-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-type/event-type-dialog.html',
                    controller: 'EventTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-type', null, { reload: true });
                }, function() {
                    $state.go('event-type');
                });
            }]
        })
        .state('event-type.edit', {
            parent: 'event-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-type/event-type-dialog.html',
                    controller: 'EventTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventType', function(EventType) {
                            return EventType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-type.delete', {
            parent: 'event-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-type/event-type-delete-dialog.html',
                    controller: 'EventTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventType', function(EventType) {
                            return EventType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
